const padding = [null, 4, 8, 16, 18, 0];

export default {
  layout: {
    flexDirection: 'column',
    height: `100vh`,
  },
  body: {
    flex: `1 1 auto`,
  },

  /** Containers */
  container: {
    maxWidth: `container`,
    px: padding,
  },
  header: {
    maxWidth: '100vw',
    px: ['16px', null, null, null, '130px'],
    py: '0',
    mx: 'auto',
  },
  narrow: {
    maxWidth: `narrow`,
    px: padding,
  },
  wide: {
    maxWidth: `wide`,
    px: padding,
  },
  medium: {
    maxWidth: `medium`,
    px: padding,
  },
  small: {
    maxWidth: `small`,
    px: padding,
  },
  full: {
    maxWidth: `none`,
  },

  /** Sticky Box */
  sticky: {
    position: `sticky`,
    top: 4,
  },
};
